
const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="theme-loader">
        <div className="loader-p" />
      </div>
    </div>
  );
};

export default Loader;

